'use client'

import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import StatsGrid from '@/components/dashboard/StatsGrid'
import UsageChart from '@/components/dashboard/UsageChart'
import AgentPerformance from '@/components/dashboard/AgentPerformance'
import PendingApprovals from '@/components/dashboard/PendingApprovals'

export default function DashboardPage() {
  return (
    <ProtectedRoute requiredRoles={['admin', 'agency_owner', 'agency_admin', 'agency_member', 'editor']}>
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
            <p className="text-gray-600">Welcome back! Here's what's happening with your AI agents.</p>
          </div>
          
          <StatsGrid />
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <UsageChart />
            <AgentPerformance />
          </div>
          
          <PendingApprovals />
        </div>
    </ProtectedRoute>
  )
}
